import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=b926be3c&scoped=true&"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplates.vue?vue&type=style&index=0&id=b926be3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b926be3c",
  null
  
)

export default component.exports